import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import TextInput from '../TextInput';
import TextArea from '../TextArea.jsx';

const HeaderRow = ({ header, onChange, onDelete }) => {
    return (
        <div className="flex items-center space-x-2 mb-2">
            <div className="flex-1">
                <TextInput
                    placeholder="Header name"
                    aria-label="Header name"
                    value={header.name || ''}
                    onChange={value => onChange({ ...header, name: value })}
                />
            </div>
            <div className="flex-1">
                <TextInput
                    placeholder="Header value"
                    aria-label="Header value"
                    value={header.value || ''}
                    onChange={value => onChange({ ...header, value: value })}
                />
            </div>
            <button
                type="button"
                onClick={onDelete}
                className="p-1 text-gray-400 hover:text-red-500"
            >
                <XMarkIcon className="w-5 h-5" />
            </button>
        </div>
    );
};

const WebhookSettings = ({ settings, setSettings }) => {
    const headers = settings?.headers || [];

    const handleHeaderChange = (index, newHeader) => {
        const newHeaders = [...headers];
        newHeaders[index] = newHeader;
        setSettings({ ...settings, headers: newHeaders });
    };

    const addHeader = () => {
        setSettings({ ...settings, headers: [...headers, { name: '', value: '' }] });
    };

    const removeHeader = (index) => {
        const newHeaders = headers.filter((_, i) => i !== index);
        setSettings({ ...settings, headers: newHeaders });
    };

    return (
        <div>
            <div className="text-sm text-gray-600 mb-4">
                Webhook POSTed the specified URL with the specified body
            </div>
            <TextInput
                label="URL"
                className="mt-4"
                value={settings?.url || ''}
                onChange={value => setSettings({ ...settings, url: value })}
            />

            <div className="mt-4">
                <div className="input-label">Headers</div>
                {headers.map((header, index) => (
                    <HeaderRow
                        key={index}
                        header={header}
                        onChange={(newHeader) => handleHeaderChange(index, newHeader)}
                        onDelete={() => removeHeader(index)}
                    />
                ))}
                <button
                    type="button"
                    onClick={addHeader}
                    className="text-primary-700 text-sm flex items-center mt-1"
                >
                    <PlusIcon className="w-4 h-4 mr-1" />
                    Add Header
                </button>
            </div>

            <TextArea
                label="Body"
                className="mt-4"
                inputClassName="min-h-32"
                value={settings?.data || ''}
                onChange={value => setSettings({ ...settings, data: value })}
            />
        </div>
    );
};

export default WebhookSettings;
